exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".local-court-form{width:550px}.local-court-form .form-input{background-color:#fff;border-radius:4px;border:1px solid #ccc;color:#333;height:32px;padding:0 4px;box-sizing:border-box;width:100%}.local-court-form .form-item-group{display:flex}.local-court-form .form-item-group div:not(:last-child){margin-right:12px}.local-court-form .form-item-group.party-name div{width:32%}.local-court-form .form-item-group.party-attorney div:first-child{width:70%}.local-court-form .form-item-group.party-attorney div:not(:first-child){margin-top:28px}.local-court-form .form-item-group.party-attorney div:not(:first-child) input[type=checkbox]{margin-right:2px}.local-court-form .form-separator{margin:32px 0}.local-court-form .form-separator strong{margin-bottom:8px}.local-court-form .form-separator hr{flex:2 1 auto;margin:7px}.local-court-form .ir-tooltip{margin-left:5px}.local-court-form .alert{white-space:pre-wrap}.local-court-form .warning{font-family:Arial,sans-serif}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/search/localCourtSearch/LocalCourtSearch.less
// module id = 1636
// module chunks = 0